type VirusMonitorTelemetryPrimitive = string | number | boolean;
export type VirusMonitorTelemetryProperties = Record<string, VirusMonitorTelemetryPrimitive>;

const virusMonitorIdentifier = 'MyArable.Virus';
const mobileMaxWidthPx = 960;

export const VirusMonitorAIIdentifiers = {
  pageViewed: `${virusMonitorIdentifier}.PageViewed`,
  tabSelected: `${virusMonitorIdentifier}.Tab.Selected`,
  overviewPageViewed: `${virusMonitorIdentifier}.Overview.PageViewed`,
  overviewRecalculateAllClicked: `${virusMonitorIdentifier}.Overview.RecalculateAll.Clicked`,
  overviewCropFieldSelectionChanged: `${virusMonitorIdentifier}.Overview.CropField.SelectionChanged`,
  overviewActionMenuOpened: `${virusMonitorIdentifier}.Overview.ActionMenu.Opened`,
  overviewActionMenuItemSelected: `${virusMonitorIdentifier}.Overview.ActionMenu.ItemSelected`,
  overviewSortChanged: `${virusMonitorIdentifier}.Overview.Sort.Changed`,
  overviewDateNavigationClicked: `${virusMonitorIdentifier}.Overview.DateNavigation.Clicked`,
  overviewDetailOpened: `${virusMonitorIdentifier}.Overview.Detail.Opened`,
  insightsPageViewed: `${virusMonitorIdentifier}.Insights.PageViewed`,
  insightsCropFieldSelected: `${virusMonitorIdentifier}.Insights.CropField.Selected`,
  insightsCalculateClicked: `${virusMonitorIdentifier}.Insights.Calculate.Clicked`,
  insightsGraphSeriesToggled: `${virusMonitorIdentifier}.Insights.GraphSeries.Toggled`,
  insightsActionMenuOpened: `${virusMonitorIdentifier}.Insights.ActionMenu.Opened`,
  insightsActionMenuItemSelected: `${virusMonitorIdentifier}.Insights.ActionMenu.ItemSelected`,
} as const;

const getDevice = (): 'mobile' | 'desktop' => {
  const browserWindow = globalThis.window;

  if (!browserWindow) {
    return 'desktop';
  }

  if (typeof browserWindow.matchMedia === 'function') {
    return browserWindow.matchMedia(`(max-width: ${mobileMaxWidthPx}px)`).matches ? 'mobile' : 'desktop';
  }

  return browserWindow.innerWidth <= mobileMaxWidthPx ? 'mobile' : 'desktop';
};

export const createVirusMonitorTelemetryProperties = (
  action: string,
  extraProperties: VirusMonitorTelemetryProperties = {},
): VirusMonitorTelemetryProperties => ({
  device: getDevice(),
  role: 'customer',
  action,
  ...extraProperties,
});
